export default "__VITE_ASSET__6a7cfb02__"